import { placeholder } from 'polished'
import { Filter } from '../icons/Filter'

export function ImprovedTextInput({
  id,
  label,
  value,
  placeholder,
  icon,
  onChange,
}: {
  id: string
  placeholder?: string
  icon?: JSX.Element
  label?: string
  value: string
  onChange: (value: string) => void
}) {
  const handleChange = (e) => {
    onChange(e.target.value)
  }

  return (
    <div className="flex flex-col gap-1 relative">
      {label && (
        <label className="font-semibold" htmlFor={id}>
          {label}
        </label>
      )}
      {!value && (
        <div className="absolute top-1/2 left-4 opacity-75 -translate-y-1/2 ">
          <p className=" flex items-center gap-2 ">
            {' '}
            {icon}
            {placeholder}{' '}
          </p>
        </div>
      )}
      <input
        className="p-4 min-w-[220px] max-w-[300px] w-full text-old-primaryLight border-[1.5px] border-gray-300 rounded-lg"
        id={id}
        value={value}
        onChange={(e) => {
          handleChange(e)
        }}
      />
    </div>
  )
}
